<script setup xmlns="http://www.w3.org/1999/html">
import { computed, defineComponent, onMounted, ref } from 'vue'
import axios from 'axios'
import { loadPayline } from '@/payline-helper.js'

defineComponent({
  name: 'FabricationCarte',
  beforeRouteLeave(to, from, next) {
    if (window._paq) {
      // On vide le panier
      window._paq.push(['clearEcommerceCart'])
      // Puis on update la commande (required)
      window._paq.push(['trackEcommerceCartUpdate'])
    }
    next()
  },
})

const erreurMessage = ref(null)

const isAchatCollapsed = ref(false)
const isPaiementCollapsed = ref(true)

const nom = ref(null)
const prenom = ref(null)
const adresse = ref(null)
const codePostal = ref(null)
const ville = ref(null)
const complementAdresse = ref(null)
const paysList = [
  'France',
  'Allemagne',
  'Andorre',
  'Belgique',
  'Espagne',
  'Italie',
  'Luxembourg',
  'Monaco',
  'Suisse',
]
const pays = ref(null)
const email = ref(null)
const mobile = ref(null)
const dateNaissance = ref(null)

const catalogue = ref([])
catalogue.value.sort((one, two) => (one.libelle > two.libelle ? 1 : -1))

const produit = ref(null)

const MAX_FILE_SIZE = 2 * 1024 * 1024 // 2 Mo

const visibiliteJustificatif = ref(false)

const motifReduit = [
  "Bénéficiaire du RSA",
  "Demandeur d'emploi",
  "Minima sociaux",
  "Titulaire d'un profil invalidité"]
const motif = ref(null)

let justificatifFile = []
const justificatifMessage = ref('')

let imageFile = null
const imageMessage = ref('')

let identiteFile = null
const imageIdentiteMessage = ref('')

const paymentToken = ref(undefined)
const isRenseignementsChecked = ref(null)
const isRGPDChecked = ref(null)
const isConditionsChecked = ref(null)
const needFacture = ref(false)

const produitErreur = ref(false)

const titrePaiementRef = ref(null)
let loading = false;

onMounted(() => {

})

// propriété calculée pour être utilisée comme variable
const calculAge = computed(() => {
  if (null !== dateNaissance.value) {
    const naissance = new Date(dateNaissance.value)
    const dateRef = new Date()

    let age = dateRef.getFullYear() - naissance.getFullYear()

    const moisDiff = dateRef.getMonth() - naissance.getMonth()
    const joursDiff = dateRef.getDate() - naissance.getDate()

    if (moisDiff < 0 || (moisDiff === 0 && joursDiff < 0)) {
      age--
    }

    return age
  }
  return null
})

function toCurrency(value) {
  if (typeof value !== 'number') {
    return value
  }
  const formatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  })
  return formatter.format(value)
}

function validerDate(date) {
  if (!date) {
    return true
  }
  return date.match(/^(\d{4})-\d{2}-\d{2}$/)
}

function fetchCatalogue() {
  erreurMessage.value = ''
  if (!validerDate(dateNaissance.value)) {
    erreurMessage.value = 'Erreur: mauvais format de date'
    dateNaissance.value = null
    return
  }

  produitErreur.value = false
  visibiliteJustificatif.value = false
  produit.value = null

  if ( dateNaissance.value !== null && isDateValid(dateNaissance.value) ) {
    axios
      .get(
        'produits/produit-vente/' +
          dateNaissance.value +
          '/' +
        new Intl.DateTimeFormat('sv-SE').format(new Date()), // obligatoire pour le endpoint
      )
      .then(
        succes => {
          catalogue.value = succes.data
        },
        erreur => {
          if (erreur.response && erreur.response.status === 400) {
            erreurMessage.value =
              erreur.response.data ||
              'Impossible de trouver votre titre, vérifiez votre saisie.'
            dateNaissance.value = null
          } else {
            erreurMessage.value =
              'Impossible de trouver votre titre, vérifiez votre saisie.'
          }
          catalogue.value = null
          console.log(erreur)
        },
      )
  }
}

function isDateValid(dateStr) {
  return !isNaN(new Date(dateStr))
}

function onChangeImageFile(event) {
  let file = event.target.files[0]
  if (file && file.type !== 'image/jpeg' && file.type !== 'image/png') {
    imageMessage.value =
      'Format incorrect. Veuillez télécharger une image JPG ou PNG.'
    event.target.value = null
  } else if (file && file.size > MAX_FILE_SIZE) {
    imageMessage.value =
      'Votre photo dépasse ' + MAX_FILE_SIZE / 1024 / 1024 + ' Mo.'
    event.target.value = null
  } else {
    imageMessage.value = ''
    imageFile = file
  }
}

function onChangeImageIdentiteFile(event) {
  let file = event.target.files[0]
  if (
    file &&
    file.type !== 'image/jpeg' &&
    file.type !== 'image/png' &&
    file.type !== 'application/pdf'
  ) {
    imageIdentiteMessage.value =
      'Format incorrect. Veuillez télécharger une image JPG,PNG ou PDF.'
    event.target.value = null
  } else if (file && file.size > MAX_FILE_SIZE) {
    imageIdentiteMessage.value =
      "Votre pièce d'identité " + MAX_FILE_SIZE / 1024 / 1024 + ' Mo.'
    event.target.value = null
  } else {
    imageIdentiteMessage.value = ''
    identiteFile = file
  }
}

function onChangeJustificatifFile(event) {
  console.log(event.target.files)
  let files = Array.from(event.target.files)
  if (files.some(file => file.size > MAX_FILE_SIZE)) {
    justificatifMessage.value =
      'Un ou plusieurs fichiers dépassent ' +
      MAX_FILE_SIZE / 1024 / 1024 +
      ' Mo.'
    event.target.value = null
    return
  }
  justificatifMessage.value = ''
  justificatifFile = files
}

function verificationJustificatif() {
  visibiliteJustificatif.value = produit.value.avecJustificatif
  produitErreur.value = false
}

function creationVente() {
  if (!produit.value) {
    produitErreur.value = true
    return
  }

  loading = true;
  produitErreur.value = false
  const formData = new FormData()
  formData.append('prenom', prenom.value)
  formData.append('nom', nom.value)
  formData.append('adresse', adresse.value)
  formData.append('codePostal', codePostal.value)
  formData.append('ville', ville.value)
  formData.append('complementAdresse', complementAdresse.value)
  formData.append('pays', pays.value)
  formData.append('dateNaissance', dateNaissance.value)
  formData.append('email', email.value)
  formData.append('mobile', mobile.value)
  formData.append('codeProduit', produit.value.codeProduit)
  formData.append('imageFile', imageFile)
  if (Array.isArray(justificatifFile)) {
    justificatifFile.forEach(file => {
      formData.append('justificatifFile', file)
    })
  } else {
    formData.append('justificatifFile', justificatifFile)
  }
  formData.append('identiteFile', identiteFile)
  formData.append('isRenseignementsChecked', isRenseignementsChecked.value)
  formData.append('isRGPDChecked', isRGPDChecked.value)
  formData.append('isConditionsChecked', isConditionsChecked.value)
  formData.append('needFacture', needFacture.value)
  formData.append('support', 'NFC')
  formData.append('reductionId', null)
  console.log('Creation vente')
  console.log(formData)
  axios
    .post('commandes/prepareFabricationCarte', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(
      succes => {
        paymentToken.value = succes.data.token
        // On récupère le token et on initialise payline
        loadPayline(succes.data.production)
          .then(() => {
            toggleCollapse()
          })
          .catch(error => {
            console.error("Erreur lors de l'initialisation de Payline", error)
            erreurMessage.value = "Erreur lors de l'initialisation de Payline."
          })
      },
      reason => {
        console.error('ERREUR', reason.response)
        if (reason.response) {
          switch (reason.response.status) {
            case 413:
              erreurMessage.value = 'Le fichier renseigné est trop volumineux.'
              break
            case 400:
              erreurMessage.value =
                'Requête invalide. Veuillez vérifier les données saisies.'
              break
            default:
              erreurMessage.value =
                reason.response.data || "Une erreur inattendue s'est produite."
          }
        } else {
          erreurMessage.value = 'Erreur réseau ou serveur non joignable.'
        }
      },
    )
    .catch(erreur => {
      console.error('Erreur lors de la création de la vente', erreur)
      erreurMessage.value =
        'Erreur lors de la création de la vente. Veuillez réessayer plus tard.'
      document.getElementById('modal_erreur').showModal()
    })
    .finally( () => {
      loading = false;
    })
}

function toggleCollapse() {
  isAchatCollapsed.value = !isAchatCollapsed.value
  isPaiementCollapsed.value = !isPaiementCollapsed.value

  nextTick(() => {
    if (isPaiementCollapsed.value === false && titrePaiementRef.value) {
      titrePaiementRef.value.focus()
    }
  })
}
</script>

<template>
  <section
    :class="{ collapse: !isPaiementCollapsed, show: isPaiementCollapsed }"
    aria-labelledby="commande-carte"
    class="overflow-auto"
  >
    <div class="achat container">
      <div class="text-center">
        <h1 id="commande-carte">Commande de carte</h1>
        <hr aria-hidden="true" />
      </div>

      <p class="text-center">
        Votre commande sera traitée dans les plus brefs délais, votre carte sera
        à récupérer à l'agence Lulu en bus
      </p>

      <div class="form_fabrication_carte">
        <div class="carte_fabrication_carte card shadow">
          <div class="card-body">
            <form @submit.prevent="creationVente">
              <fieldset class="form-group">
                <legend class="fw-bold h6">
                  Indiquez les informations du titulaire du titre de transport
                </legend>

                <div class="div_icon_input row align-items-center mb-3 mt-3">
                  <div class="col-sm-1 text-center d-none d-sm-block">
                    <i class="fas fa-user fa-2x" aria-hidden="true"></i>
                  </div>
                  <div class="col-sm-11 col-xs-10">
                    <label for="nom-input" class="visually-hidden">Nom</label>
                    <input
                      id="nom-input"
                      v-model="nom"
                      type="text"
                      class="form-control"
                      placeholder="Nom"
                      autocomplete="family-name"
                      required
                    />
                  </div>
                </div>

                <div class="div_icon_input row">
                  <div class="col-sm-11 col-xs-10 offset-sm-1">
                    <label for="prenom-input" class="visually-hidden"
                      >Prénom</label
                    >
                    <input
                      id="prenom-input"
                      v-model="prenom"
                      type="text"
                      class="form-control"
                      placeholder="Prénom"
                      autocomplete="given-name"
                      required
                    />
                  </div>
                </div>

                <div class="div_icon_input row">
                  <div class="col-sm-1 text-center d-none d-sm-block">
                    <i
                      class="fa-solid fa-location-dot fa-2x"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div class="col-sm-11 col-xs-10">
                    <label for="adresse-input" class="visually-hidden"
                      >Adresse</label
                    >
                    <input
                      id="adresse-input"
                      v-model="adresse"
                      type="text"
                      class="form-control"
                      placeholder="Adresse"
                      autocomplete="address-line1"
                      required
                    />
                  </div>
                </div>

                <div class="div_icon_input row">
                  <div class="col-5 offset-sm-1">
                    <label for="codePos-input" class="visually-hidden"
                      >Code Postal</label
                    >
                    <input
                      id="codePos-input"
                      v-model="codePostal"
                      type="text"
                      class="form-control input-adresse"
                      placeholder="Code Postal"
                      autocomplete="postal-code"
                      required
                    />
                  </div>
                  <div class="col-5">
                    <label for="ville-input" class="visually-hidden"
                      >Ville</label
                    >
                    <input
                      id="ville-input"
                      v-model="ville"
                      type="text"
                      class="form-control"
                      placeholder="Ville"
                      autocomplete="address-level2"
                      required
                    />
                  </div>
                </div>

                <div class="div_icon_input row">
                  <div class="col-sm-11 col-xs-10 offset-sm-1">
                    <label for="compAdresse-input" class="visually-hidden"
                      >Complément d'adresse (Numéro appartement, Bâtiment,
                      etc)</label
                    >
                    <input
                      id="compAdresse-input"
                      v-model="complementAdresse"
                      type="text"
                      class="form-control"
                      placeholder="Complément d'adresse (Numéro appartement, Bâtiment, etc)"
                      autocomplete="address-line2"
                    />
                  </div>
                </div>

                <div class="div_icon_input row">
                  <div class="col-sm-1 text-center d-none d-sm-block">
                    <i class="fa-solid fa-flag fa-2x" aria-hidden="true"></i>
                  </div>

                  <div class="col-sm-11 col-xs-10">
                    <label for="pays"
                      >Veuillez choisir le pays dans lequel vous vous
                      situez</label
                    >
                    <select
                      id="pays"
                      class="form-control"
                      required
                      @change="pays = $event.target.value"
                      autocomplete="country"
                    >
                      <option value="">Veuillez sélectionner un pays</option>
                      <option
                        v-for="item in paysList"
                        :key="item"
                        :value="item"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="div_icon_input row">
                  <div class="col-sm-1 text-center d-none d-sm-block">
                    <i class="fas fa-envelope" aria-hidden="true"></i>
                  </div>
                  <div class="col-sm-11 col-xs-10">
                    <label for="email-input" class="visually-hidden"
                      >Adresse E-mail</label
                    >
                    <input
                      id="email-input"
                      v-model="email"
                      type="email"
                      class="form-control"
                      placeholder="Adresse E-mail"
                      autocomplete="email"
                      required
                    />
                  </div>
                </div>

                <div class="div_icon_input row">
                  <div class="col-sm-1 text-center d-none d-sm-block">
                    <i class="fas fa-mobile" aria-hidden="true"></i>
                  </div>
                  <div class="col-sm-11 col-xs-10">
                    <label for="telFormControlInput" class="visually-hidden"
                      >Mobile avec indicatif (+33 pour la france)</label
                    >
                    <input
                      v-model="mobile"
                      type="tel"
                      maxlength="12"
                      class="form-control"
                      id="telFormControlInput"
                      placeholder="Mobile avec indicatif (+33 pour la france)"
                      autocomplete="tel"
                      required
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-1 d-none d-sm-block"></div>
                  <label for="dateDeNaissance" class="col-sm-11 col-xs-10"
                    >Date de naissance</label
                  >
                </div>
                <div class="div_icon_input row">
                  <div class="col-sm-1 text-center d-none d-sm-block">
                    <i class="fas fa-calendar" aria-hidden="true"></i>
                  </div>
                  <div class="col-sm-11 col-xs-10">
                    <label for="dateDeNaissance" class="visually-hidden"
                      >Date de naissance</label
                    >
                    <input
                      type="date"
                      class="form-control"
                      v-model="dateNaissance"
                      id="dateDeNaissance"
                      @blur="fetchCatalogue"
                      autocomplete="bday"
                      required
                    />
                  </div>
                </div>
              </fieldset>

              <fieldset class="form-group pt-4">
                <legend class="fw-bold h6">
                  Sélectionnez le produit souhaité :
                </legend>

                <div class="form-group pt-4">
                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-barcode" aria-hidden="true"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <label for="choix-produit" class="visually-hidden"
                        >Sélectionnez le produit souhaité</label
                      >
                      <select
                        class="form-control"
                        id="choix-produit"
                        required
                        v-model="produit"
                        @change="verificationJustificatif()"
                        :disabled="!dateNaissance"
                        aria-describedby="erreurs-produit"
                        :aria-invalid="produitErreur ? 'true' : 'false'"
                      >
                        <option :value="null" disabled>
                          Veuillez sélectionner un produit
                        </option>
                        <option
                          v-for="item in catalogue"
                          :key="item.id"
                          :value="item"
                        >
                          {{ item.libelle }} ({{ toCurrency(item.tarif) }})
                        </option>
                      </select>
                      <div id="erreurs-produit" aria-live="polite">
                        <p v-if="produitErreur" class="text-danger">
                          Veuillez sélectionner un produit
                        </p>
                        <p
                          v-if="!dateNaissance"
                          class="text-warning-emphasis"
                        >
                          Veuillez remplir les champs "Date de naissance" pour choisir un produit.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <legend class="fw-bold h6">Pièces justificatives :</legend>

                <div
                  v-if="
                    visibiliteJustificatif && calculAge > 18 && calculAge < 65
                  "
                  class="div_icon_input row"
                >
                  <div class="col-sm-1 text-center d-none d-sm-block">
                    <i
                      class="fa-solid fa-folder-open fa-2x"
                      aria-hidden="true"
                    ></i>
                  </div>

                  <div class="col-sm-11 col-xs-10">
                    <label for="reduit"
                      >Veuillez choisir un motif vous donnant accès à cette
                      tarification</label
                    >
                    <select
                      id="reduit"
                      class="form-control"
                      required
                      @change="motif = $event.target.value"
                      autocomplete=""
                    >
                      <option value="">Veuillez sélectionner un motif</option>
                      <option
                        v-for="item in motifReduit"
                        :key="item"
                        :value="item"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>

                <div
                  v-if="null != motif"
                  id="desc-justificatif"
                  class="info_mail mb-1"
                >
                  <p v-if="
                  motif === 'Bénéficiaire du RSA' ||
                  motif === 'Demandeur d\'emploi' ||
                  motif === 'Minima sociaux'" >
                    Le produit sélectionné nécessite de fournir une attestation
                    de droits ou Attestation CSS
                  </p>

                  <p v-else-if="motif === 'Titulaire d\'un profil invalidité'">
                    Le produit sélectionné nécessite de fournir en justificatif
                    votre carte d’invalidité
                  </p>

                  <p v-else>
                    Le produit sélectionné nécessite de fournir un justificatif.
                  </p>
                </div>

                <div v-if="null != motif" class="div_icon_input row">
                  <div class="col-sm-1 text-center d-none d-sm-block">
                    <i class="fas fa-file" aria-hidden="true"></i>
                  </div>
                  <div class="col-sm-11 col-xs-10">
                    <label for="justificatif-input" class="visually-hidden"
                      >Téléchargez le document justificatif pour le tarif
                      réduit</label
                    >
                    <input
                      ref="justificatifInput"
                      id="justificatif-input"
                      type="file"
                      @change="onChangeJustificatifFile($event)"
                      accept="application/pdf,image/png,image/jpeg"
                      class="form-control"
                      aria-describedby="desc-justificatif msg-justif"
                      multiple
                      required
                    />
                    <p
                      id="msg-justif"
                      aria-live="polite"
                      :style="{
                        color:
                          justificatifMessage.value === 'Format correct.'
                            ? 'green'
                            : 'red',
                      }"
                    >
                      {{ justificatifMessage }}
                    </p>
                  </div>
                </div>

                <p id="desc-photo" class="info_mail">
                  Personnalisez la carte avec la photo d'identité du futur
                  détenteur (Photo cadrée, droite et nette)
                </p>

                <div class="div_icon_input row">
                  <div class="col-sm-1 text-center d-none d-sm-block">
                    <i class="fas fa-file" aria-hidden="true"></i>
                  </div>
                  <div class="col-sm-11 col-xs-10">
                    <label for="photoID-input" class="visually-hidden"
                      >Téléchargez le fichier de la photo d'identité du futur
                      détenteur (Photo cadrée, droite et nette)
                    </label>

                    <input
                      ref="imageInput"
                      id="photoID-input"
                      type="file"
                      @change="onChangeImageFile($event)"
                      accept="image/png,image/jpeg"
                      class="form-control"
                      aria-describedby="desc-photo msg-photo"
                      required
                    />
                    <p
                      id="msg-photo"
                      aria-live="polite"
                      :style="{
                        color:
                          imageMessage.value === 'Format correct.'
                            ? 'green'
                            : 'red',
                      }"
                    >
                      {{ imageMessage }}
                    </p>
                  </div>
                </div>

                <p id="desc-pieceID" class="info_mail">
                  Téléchargez une pièce d'identité (passeport / carte résident /
                  carte séjour)
                </p>
                <div class="div_icon_input row">
                  <div class="col-sm-1 text-center d-none d-sm-block">
                    <i class="fas fa-file" aria-hidden="true"></i>
                  </div>
                  <div class="col-sm-11 col-xs-10">
                    <label for="pieceID-input" class="visually-hidden"
                      >Fichier de la pièce d'identité du futur détenteur
                      (passeport / carte résident / carte séjour)</label
                    >
                    <input
                      ref="imageInput"
                      id="pieceID-input"
                      type="file"
                      @change="onChangeImageIdentiteFile($event)"
                      accept="application/pdf,image/png,image/jpeg"
                      class="form-control"
                      aria-describedby="desc-pieceID msg-pieceID"
                      required
                    />
                    <p
                      id="msg-pieceID"
                      aria-live="polite"
                      :style="{
                        color:
                          imageMessage.value === 'Format correct.'
                            ? 'green'
                            : 'red',
                      }"
                    >
                      {{ imageIdentiteMessage }}
                    </p>
                  </div>
                </div>
              </fieldset>

              <fieldset class="form-group consent">
                <legend class="visually-hidden">
                  Consentements et validations
                </legend>
                <p>
                  <input
                    id="renseignement"
                    v-model="isRenseignementsChecked"
                    type="checkbox"
                    required
                  />
                  <label for="renseignement">
                    Je certifie l'exactitude des renseignements fournis dans ce
                    formulaire.</label
                  >
                </p>

                <p>
                  <input
                    id="rgpd"
                    v-model="isRGPDChecked"
                    type="checkbox"
                    required
                  />
                  <label for="rgpd">
                    J'accepte que mes données personnelles soient collectées et
                    traitées conformément à la RGPD.</label
                  >
                </p>

                <p>
                  <input
                    id="cgv"
                    v-model="isConditionsChecked"
                    type="checkbox"
                    required
                  />
                  <label for="cgv">
                    Je déclare avoir pris connaissance et accepte les
                    <a target="_blank" href="CGV-luneo.pdf">
                      conditions générales des ventes du service et le règlement
                      des transports
                      <span class="visually-hidden">
                        (PDF, nouvelle fenêtre)</span
                      >
                    </a>
                    .
                  </label>
                </p>

                <p>
                  <input id="facture" v-model="needFacture" type="checkbox" />
                  <label for="facture"> Je souhaite avoir une facture.</label>
                </p>

                <button type="submit" class="bouton_valid btn btn-lg" :disabled="loading">
                  Valider
                  <i class="fas fa-arrow-right" aria-hidden="true"></i>
                </button>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    :class="{ collapse: isPaiementCollapsed, show: !isPaiementCollapsed }"
    aria-labelledby="titre-paiement"
  >
    <div class="paiement container">
      <h1 id="titre-paiement" tabindex="-1" ref="titrePaiementRef">
        Finalisation de votre achat - Paiement
      </h1>
      <hr aria-hidden="true" />

      <div class="card">
        <div class="card-body">
          <h2 class="card-title">Récapitulatif de votre achat</h2>
          <p class="card-text">Titulaire : {{ prenom }} {{ nom }}</p>
          <p v-if="produit && produit.tarif !== null" class="card-text">
            Montant : {{ toCurrency(produit.tarif) }}
          </p>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div v-if="paymentToken">
            <div
              id="PaylineWidget"
              :data-token="paymentToken"
              data-template="column"
              data-auto-init="true"
              data-embeddedredirectionallowed="false"
            />
          </div>
          <p v-else class="text-danger">Token de paiement non disponible.</p>
        </div>
      </div>
    </div>
  </section>

  <dialog
    id="modal_erreur"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="titre-modal-erreur"
  >
    <div class="carte">
      <div>
        <h2 id="titre-modal-erreur" class="visually-hidden">Erreur</h2>
        <p class="description text-danger">{{ erreurMessage }}</p>
        <button type="button" @click="closeModal">Fermer</button>
      </div>
    </div>
  </dialog>
</template>

<style scoped lang="scss">
@use '@/sass/mixins' as *;

h1 {
  color: var(--firstcolor);
}

legend {
  margin-bottom: 1rem;
}

p {
  font-weight: bold;
}

.carte_fabrication_carte {
  @include card_shadow;

  .div_icon_input {
    @include icon_form;
    display: flex;
    align-items: center;
    margin-bottom: 1rem;

    &:focus-within {
      i {
        color: var(--firstcolor);
      }
    }
  }

  .info_mail {
    margin-top: 3rem;
  }

  .bouton_valid {
    display: block;
    margin: auto;
    @include boutons;
  }

  .bouton_valid:hover,
  .bouton_valid:focus {
    @include boutons_hover;
  }

  fieldset.consent input[type="checkbox"]{
    margin-right: 5px;
  }
}
</style>
